import { useRef, useCallback } from 'react';

/**
 * Hook personalizado para persistir el estado del formulario durante re-renders
 * causados por eventos en tiempo real
 */
export const useFormPersistence = (form) => {
  const formValuesRef = useRef(null);
  const isUserInputRef = useRef(false);

  // Guardar valores actuales del formulario
  const saveFormValues = useCallback(() => {
    if (form && isUserInputRef.current) {
      formValuesRef.current = form.getFieldsValue();
    }
  }, [form]);

  // Restaurar valores del formulario
  const restoreFormValues = useCallback(() => {
    if (form && formValuesRef.current && isUserInputRef.current) {
      form.setFieldsValue(formValuesRef.current);
    }
  }, [form]);

  // Marcar que el usuario ha empezado a interactuar con el formulario
  const markUserInput = useCallback(() => {
    isUserInputRef.current = true;
  }, []);

  // Limpiar el estado persistente
  const clearPersistentState = useCallback(() => {
    formValuesRef.current = null;
    isUserInputRef.current = false;
  }, []);

  // Inicializar formulario solo si no hay valores persistentes
  const initializeForm = useCallback((defaultValues) => {
    if (form && !isUserInputRef.current) {
      form.setFieldsValue(defaultValues);
    }
  }, [form]);

  return {
    saveFormValues,
    restoreFormValues,
    markUserInput,
    clearPersistentState,
    initializeForm,
    hasUserInput: () => isUserInputRef.current,
  };
};